/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';


class pageNull extends React.Component {
  constructor () {
    super();
  }

  render() {
    return (
      <div>
        <h1>没有当前页面</h1>
        <h2>请输入正确地址</h2>
      </div>
    );
  }
}

export default pageNull;



// WEBPACK FOOTER //
// src/routes/exportPDF/pageNull/index.js